import axiosInstance from "./axiosInstance";

/**
 * The decision about a candidate: undecided | shortlisted | backlog | rejected. Exactly one value,
 * always — which is why this replaced the shortlist add/remove pair. Shortlisted and Rejected were
 * never two switches; they are two positions of one dial.
 *
 * There is deliberately NO read endpoint. The read path is the "Decision" field on each ranking
 * row, so decisions arrive with the candidates and never need a second fetch.
 */
export const setDecisionAPI = async (jobId, resumeIds, decision) => {
  try {
    const response = await axiosInstance.put(`jobs/${jobId}/decision`, {
      resume_ids: resumeIds,
      decision,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update the decision.");
  }
};
